import { useForm } from 'react-hook-form'
import { api } from '~/util/api'

export const useProgramSurveyForm = ({
  surveyType,
  questions,
  candidate_id,
  company_id,
  setError,
  setThankYou,
}) => {
  const defaultValues = {
    content: {},
    candidate_id: candidate_id,
    company_id: company_id,
    product: 'OUTPLACEMENT',
  }

  const form = useForm({
    defaultValues,
  })

  async function onSubmit(data) {
    let response
    console.log('Submitting survey with data:', data)
    try {
      response = await api.post(`/visitor_surveys`, {
        survey_type: surveyType,
        survey: {
          content: getSurveyData(data, questions),
          candidate_id: data.candidate_id,
          company_id: data.company_id,
          product: data.product,
        },
      })
    } catch (error) {
      console.error(error)
      setError(true)
      return
    }
    if (response.status === 201) {
      setThankYou(true)
    } else {
      console.log(response)
      setError(true)
    }
  }

  const getSurveyData = (values, questions) => {
    const surveyData = {}
    if (!questions) return surveyData
    Object.entries(questions).forEach(([key, question]) => {
      surveyData[key] = values[question.name]
    })
    return surveyData
  }

  return { form, onSubmit }
}
